import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenDe = () => {
    return <AddStartpageComToYourHomeScreen languageCode="de" />
}

export default AddStartpageComToYourHomeScreenDe
